import {
  MemberFilters,
  MemberFiltersDrawer,
  MemberListHeader,
  MembersTable
} from '@bo-components/members/membersList';
import type {
  MemberSearchFilterParam,
  MembersContext
} from '@library/types/members';
import { Loading } from '@library/components/Loading';
import { useCallback } from 'react';
import { useMembers } from '@bo-hooks/members';
import { useOutletContext } from 'react-router-dom';

export const Members = () => {
  const {
    isFiltersDrawerOpen,
    memberSearchFilters,
    onChangeSearchMemberFilter,
    onResetSearchMemberFilters,
    onSubmitSearchMemberFilters,
    onToggleFiltersDrawer
  } = useOutletContext<MembersContext>();

  const {
    formattedMembers,
    isLoadingMembers,
    onPageChange,
    onResetPageChange
  } = useMembers({
    memberSearchFilters
  });

  const handleChangeSearchFilterValue = useCallback(
    ({ key, value }: MemberSearchFilterParam) => {
      onChangeSearchMemberFilter({ key, value });
      onResetPageChange();
    },
    [onChangeSearchMemberFilter, onResetPageChange]
  );

  const handleToggleFiltersDrawer = useCallback(
    (isOpen?: boolean) => onToggleFiltersDrawer(!!isOpen),
    [onToggleFiltersDrawer]
  );

  return (
    <>
      <div className="flex w-full flex-col gap-4 py-3">
        <MemberListHeader memberSearchFilters={memberSearchFilters} />
        <div className="flex flex-col gap-4 px-6">
          <MemberFilters
            memberSearchFilters={memberSearchFilters}
            onChangeSearchMemberFilter={handleChangeSearchFilterValue}
            onResetSearchMemberFilters={onResetSearchMemberFilters}
            onToggleFiltersDrawer={handleToggleFiltersDrawer}
          />
          {isLoadingMembers ? (
            <Loading loadingMessage="Loading Members" />
          ) : (
            <MembersTable
              formattedMembers={formattedMembers}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>
      {isFiltersDrawerOpen && (
        <MemberFiltersDrawer
          memberSearchFilters={memberSearchFilters}
          onClose={handleToggleFiltersDrawer}
          onResetFilters={onResetSearchMemberFilters}
          onSubmit={onSubmitSearchMemberFilters}
        />
      )}
    </>
  );
};
